"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.builder = void 0;
exports.builder = {
    any: () => {
        const subRules = [];
        const withSubRule = (rule) => {
            subRules.push(rule);
            return { withSubRule, build };
        };
        const build = (errorMessage) => ({
            type: 'COMPOSITE',
            algorithm: 'any',
            errorMessage,
            subRules,
        });
        return { withSubRule };
    },
    all: () => {
        const subRules = [];
        const withSubRule = (rule) => {
            subRules.push(rule);
            return { withSubRule, build };
        };
        const build = (errorMessage) => ({
            type: 'COMPOSITE',
            algorithm: 'all',
            errorMessage,
            subRules,
        });
        return { withSubRule };
    },
};
//# sourceMappingURL=CompositeRuleBuilder.js.map